module.exports = __webpack_public_path__ + "static/fonts/TrebuchetMS-Bold.37d7030.eot";